var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.396 43.396"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39",
    d: "M31.868 29.788h-3.929v-6.145c0-1.467-.029-3.353-2.043-3.353-2.046 0-2.358 1.6-2.358 3.245v6.253h-3.926v-12.64h3.768v1.728h.054a4.128 4.128 0 013.719-2.042c3.977 0 4.714 2.617 4.714 6.021zM17.459 13.141a2.279 2.279 0 01-2.278 2.279 2.278 2.278 0 01-2.28-2.279 2.278 2.278 0 012.28-2.277 2.279 2.279 0 012.278 2.277m-4.247 4.006h3.935v12.64h-3.935zm30.184 4.55a21.7 21.7 0 00-21.7-21.7 21.7 21.7 0 00-21.7 21.7 21.7 21.7 0 0021.7 21.7 21.7 21.7 0 0021.7-21.7",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "e30372ba2f7ecb180637d65b8385eab0.svg";
export { SvgLinkedinCircle as ReactComponent };